/**
 * Liste des doc_type CEE TRA-EQ-131 + libelles UI.
 * Source de verite cote client (mirroir de server/src/services/cee/constants.js).
 *
 * Utilise par CeeDossierDetailPage pour generer la grille des cartes documents.
 */

/** @typedef {{ key: string, label: string, isGenerated: boolean, description: string }} DocTypeMeta */

/** @type {ReadonlyArray<DocTypeMeta>} */
export const DOC_TYPE_META = Object.freeze([
  Object.freeze({
    key: 'urssaf', label: 'URSSAF', isGenerated: false,
    description: 'Attestation de vigilance URSSAF',
  }),
  Object.freeze({
    key: 'liasse_2059_e', label: 'Liasse 2059-E', isGenerated: false,
    description: 'Declaration fiscale 2059-E (effectif moyen, ETP)',
  }),
  Object.freeze({
    key: 'kbis', label: 'Kbis', isGenerated: false,
    description: 'Extrait Kbis (registre du commerce)',
  }),
  Object.freeze({
    key: 'cni', label: 'CNI', isGenerated: false,
    description: 'CNI du representant legal',
  }),
  Object.freeze({
    key: 'devis', label: 'Devis', isGenerated: true,
    description: 'Devis genere selon le template du mandataire (signe Docage)',
  }),
  Object.freeze({
    key: 'ah', label: 'Attestation honneur', isGenerated: true,
    description: 'AH genere selon le template du mandataire (signe Docage)',
  }),
  Object.freeze({
    key: 'facture', label: 'Facture', isGenerated: true,
    description: 'Facture (AM ENERGIE uniquement, autres mandataires editent hors-app)',
  }),
  Object.freeze({
    key: 'autre', label: 'Autre', isGenerated: false,
    description: 'Document divers (non classifie automatiquement)',
  }),
]);

/**
 * Retourne la metadata d un doc_type.
 * @param {string} key
 * @returns {DocTypeMeta | undefined}
 */
export function getDocTypeMeta(key) {
  return DOC_TYPE_META.find((d) => d.key === key);
}
